import React from 'react';
import { Helmet } from "react-helmet";

const PageHelmet = ({ pageTitle }) => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                <meta name="robots" content="index, follow" />
                <title>{pageTitle} - eLearning</title>
                <meta name="description" content="Modern E-learning Solutions that are changing education. Find intriguing online courses and resources to help you study more effectively." />
            </Helmet>
        </>
    );
};

export default PageHelmet;